import { render } from "./ProductInformation.vue?vue&type=template&id=1dec7776&scoped=true&ts=true"
import script from "./ProductInformation.vue?vue&type=script&lang=ts"
export * from "./ProductInformation.vue?vue&type=script&lang=ts"

import "./ProductInformation.vue?vue&type=style&index=0&id=1dec7776&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dec7776"]])

export default __exports__